import { render } from "./SelectWidget.vue?vue&type=template&id=13b02708&scoped=true&ts=true"
import script from "./SelectWidget.vue?vue&type=script&lang=ts"
export * from "./SelectWidget.vue?vue&type=script&lang=ts"

import "./SelectWidget.vue?vue&type=style&index=0&id=13b02708&lang=scss&scoped=true"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b02708"]])

export default __exports__